import { string, object, array } from 'yup'

export type Endpoints = {
  production: string[]
  development: string[]
}

const EndpointSchema = array().of(string())

const EndpointsSchema = object().shape({
  production: EndpointSchema,
  pilot: EndpointSchema,
  development: EndpointSchema,
})

export default EndpointsSchema
